(function () {
  const scope = document.querySelector('[data-blog-infinite]');
  if (!scope) return;

  const grid = scope.querySelector('#BlogInfiniteGrid');
  const sentinel = scope.querySelector('#BlogInfiniteSentinel');
  const pagination = scope.querySelector('#BlogPagination');
  if (!grid || !sentinel || !pagination) return;

  // Hide pagination UI, but we still read it to find the next URL.
  pagination.style.display = 'none';

  const loadedUrls = new Set();

  const normalizeUrl = (url) => {
    try {
      const u = new URL(url, window.location.origin);
      // Only keep path + search (avoid hash differences)
      return u.pathname + u.search;
    } catch (e) {
      return url;
    }
  };

  const getNextUrl = (rootDoc) => {
    const within = rootDoc.querySelector('#BlogPagination') || rootDoc;

    // Prefer explicit "next" patterns
    const candidates = [
      'a[rel="next"]',
      'a[aria-label="Next"]',
      'a[aria-label="next"]',
      '.pagination a.next',
      '.pagination .next a',
      'a.pagination-next',
      'a.next'
    ];

    for (const sel of candidates) {
      const a = within.querySelector(sel);
      if (a && a.href) return a.href;
    }

    // If none found, do NOT guess "last link" (that often causes repeats)
    return null;
  };

  let loading = false;
  let nextUrl = getNextUrl(document);

  async function loadNext() {
    if (loading || !nextUrl) return;

    const key = normalizeUrl(nextUrl);
    if (loadedUrls.has(key)) {
      // We already loaded this URL — stop to prevent repeats.
      nextUrl = null;
      return;
    }

    loading = true;
    loadedUrls.add(key);

    try {
      const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('Fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#BlogInfiniteGrid');
      if (newGrid) {
        Array.from(newGrid.children).forEach((el) => grid.appendChild(el));
      }

      // Set the next URL from the fetched page's pagination
      nextUrl = getNextUrl(doc);

      // Extra protection: if nextUrl resolves to something we already loaded, stop.
      if (nextUrl && loadedUrls.has(normalizeUrl(nextUrl))) {
        nextUrl = null;
      }
    } catch (e) {
      nextUrl = null;
    } finally {
      loading = false;
    }
  }

  const io = new IntersectionObserver(
    (entries) => {
      if (entries.some((e) => e.isIntersecting)) loadNext();
    },
    { rootMargin: '800px' }
  );

  io.observe(sentinel);
})();
